import { render } from "./ApparelCarbonLab.vue?vue&type=template&id=0e520d32&scoped=true"
import script from "./ApparelCarbonLab.vue?vue&type=script&lang=js"
export * from "./ApparelCarbonLab.vue?vue&type=script&lang=js"

import "./ApparelCarbonLab.vue?vue&type=style&index=0&id=0e520d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e520d32"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QBanner,QIcon,QTabs,QTab,QTabPanels,QTabPanel,QChip,QCard,QCardSection,QSelect,QInput,QBtn,QLinearProgress,QSlider,QExpansionItem});
